import styled from 'styled-components'
import { components } from 'react-select'

import colors from 'components/utils/colors'
import { InnerComponent } from 'components/utils/innerReactSelectComponents'

import { StyledDropdownIndicator } from './DropdownIndicator'

const StyledControl = styled(InnerComponent).attrs({ Component: components.Control })`
  &.react-select__control {
    font-size: 14px;
    line-height: 16px;
    min-height: 32px;
    box-shadow: none;
    border-radius: 3px;
    border-color: ${props => props.selectProps.isError ? colors.alert : colors.secondary70};
    cursor: pointer;

    &:hover, &.react-select__control--is-focused {
      border-color: ${props => props.selectProps.isError ? colors.alert : colors.primary40};
    }
  }

  .react-select__value-container {
    padding: 7px 0 7px 8px;
    row-gap: 8px;
    line-height: 16px;
    cursor: ${props => props.selectProps.isSearchable ? 'text' : 'pointer'};
  }

  &:hover, &.react-select__control--menu-is-open {
    ${StyledDropdownIndicator} {
      color: ${colors.primary40};
    }
  }

  &.react-select__control--is-disabled {
    background-color: #FFFFFF;
    border-color: ${colors.secondary90};

    .react-select__placeholder {
      color: ${colors.secondary80};
    }
  }

  .react-select__placeholder {
    color: ${colors.secondary70};
  }

  .react-select__input-container {
    margin: 0;
    padding: 0;
    .react-select__input {
      margin: 0;
      height: 16px;
    }
  }
`
const SelectControl = (props) => {
  return <StyledControl {...props} />
}

export default SelectControl
